export default "__VITE_ASSET__05815fc1__"